/**
 * FixedNav class definition
 *
 * @author caiocosta
 * @date 13/02/15
 */

!function ($) {
	var FixedNav = function (nav) {
		this.setNav(nav)
			.init();
	};

	FixedNav.prototype = {
		constructor: FixedNav,

		init: function () {
			this.cloneNav()
				.registerListeners();
		},

		cloneNav: function () {
			var fixedNav =
				this.getNav()
					.clone()
					.addClass('fixed')
					.removeClass('collapse');

			fixedNav.insertAfter(this.getNav());

			this.setFixedNav(fixedNav);

			return this;
		},

		showFixedNav: function () {
			this.getFixedNav().show();

			return this;
		},

		hideFixedNav: function () {
			this.getFixedNav().hide();

			return this;
		},

		registerListeners: function () {
			var that = this;

			$(document).on('ready.fixedNav dismiss.softlaunchbar show.softlaunchbar', function () {
				that.updateFixedNavState();
			});

			$(window).on('load.fixedNav resize.fixedNav scroll.fixedNav', function () {
				that.updateFixedNavState();
			});

			return this;
		},

		updateFixedNavState: function () {
			var hiddenMaxPoint = (this.getNavOffsetTop() - this.getAdminBarHeight()) - ($('body').data('baseOffsetTop') || 0);

			if (this.getScrollY() >= hiddenMaxPoint) {
				this.getFixedNav().css('top', this.getFixedNavTopPosition());
				this.showFixedNav();
			}
			else {
				this.hideFixedNav();
			}
		},


		/**
		 * Accessors and Mutators
		 */

		// Properties
		// -------------------------

		getNav: function () {
			return this.nav;
		},

		setNav: function (nav) {
			this.nav = $(nav);
			return this;
		},

		getFixedNav: function () {
			return this.fixedNav;
		},

		setFixedNav: function (nav) {
			this.fixedNav = $(nav);
			return this;
		},


		// External resources
		// -------------------------

		getScrollY: function () {
			return $(window).scrollTop();
		},

		getAdminBarHeight: function () {
			if (typeof this.adminBar == 'undefined') {
				this.adminBar = $('#wpadminbar');

				if (this.adminBar.length == 0) {
					this.adminBar = false;
				}
			}

			return (this.adminBar ? this.adminBar.height() : 0);
		},

		getNavOffsetTop: function () {
			return this.getNav().offset().top;
		},

		getFixedNavTopPosition: function () {
			return ($('body').data('baseOffsetTop') || 0) + this.getAdminBarHeight();
		}
	};

	$.fn.fixedNav = function () {
		this.each(function () {
			new FixedNav(this);
		})
	}

}(window.jQuery);
